module.exports = __webpack_public_path__ + "img/2_3.6e3afa19.png";